import {css, cx as addStyles} from '@emotion/css';
import {round, SustainabilityImpact} from '@remoov/functional';
import {theme} from '@remoov/remoov-components';
import React, {HTMLAttributes} from 'react';
import {DashboardCard, DashboardCardTitle, textBaseStyle} from './Common';

export const SustainabilityImpactCard = ({
  sustainabilityImpact,
}: {
  sustainabilityImpact: SustainabilityImpact;
}) => (
  <DashboardCard>
    <DashboardCardTitle>Sustainability Impact</DashboardCardTitle>
    <CategoriesContainer>
      <CategoryContainer>
        <CategoryTitle>CO2 REDUCTION</CategoryTitle>
        <CategoryValue>{`${round(sustainabilityImpact.CO2Reduction_lbs, 2)} Pounds`}</CategoryValue>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>DIVERTED LANDFILL</CategoryTitle>
        <CategoryValue>{`${round(
          sustainabilityImpact.divertedLandfill_lbs,
          2,
        )} Pounds`}</CategoryValue>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>TREE ABS. EQUIVALENT</CategoryTitle>
        <CategoryValue>{`${round(
          sustainabilityImpact.treeAbsorptionEquiv,
          0,
        )} Trees`}</CategoryValue>
      </CategoryContainer>

      <CategoryContainer>
        <CategoryTitle>TIME SAVED</CategoryTitle>
        <CategoryValue>{`${round(sustainabilityImpact.timeSaved_hours, 0)} Hours`}</CategoryValue>
      </CategoryContainer>
    </CategoriesContainer>
  </DashboardCard>
);
const CategoriesContainer = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacings.small,
      [theme.mediaMaxWidth.small_medium]: {flexDirection: 'column'},
    })}
    {...args}
  />
);
const CategoryContainer = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      width: '200px',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacings.xxsmall,
    })}
    {...args}
  />
);
const CategoryTitle = (args: HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={addStyles(textBaseStyle, css({fontWeight: theme.font.medium}))} {...args} />
);
const CategoryValue = (args: HTMLAttributes<HTMLParagraphElement>) => (
  <p className={addStyles(textBaseStyle, css({fontWeight: theme.font.light}))} {...args} />
);
